var map = {
	"./facebookIcon.svg": 5533,
	"./instagramIcon.svg": 441,
	"./twitterIcon.svg": 2284,
	"Common/Assets/Icons/Socials/facebookIcon.svg": 5533,
	"Common/Assets/Icons/Socials/instagramIcon.svg": 441,
	"Common/Assets/Icons/Socials/twitterIcon.svg": 2284
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3967;